export default {
  btnAdd:'Add category',
  btnEdit:'Edit',
  btnDelete:'Delete',
  success : 'success',
  deleted : 'Deleted',
  error : 'Error'

}
